import { useTaskSidePanel } from '../task-side-panel/TaskSidePanelContext';
import { SharedFileViewer } from './SharedFileViewer';

/**
 * The shared-file viewer as a STACK ENTRY, reading its exit from the stack at RENDER time.
 *
 * It cannot be handed `back` at creation time, which is the bug this exists to prevent: the thread is
 * usually the bottom of the stack, so `back` is `undefined` in the render that builds this node, and a
 * captured `popModal ?? closeModal` resolves to `closeModal` forever. Closing the file would then empty
 * the whole stack and throw the thread away — the opposite of what the back label promises.
 *
 * By the time this component renders it IS the top entry, so `back` is defined and pops to the thread.
 * `closeModal` remains the fallback for the case where it somehow is not, because a viewer with no exit
 * is worse than one that exits too far. Same pattern as `TaskDetailModal`, which reads `back`/`backLabel`
 * from the context itself rather than taking them as props.
 */
export function StackedSharedFileViewer({ fileId, fileName }: { fileId: string; fileName?: string }) {
  const { back, closeModal: close } = useTaskSidePanel();
  return <SharedFileViewer fileId={fileId} fileName={fileName} onClose={back ?? close} />;
}
